import * as yup from "yup";

export const mapFilters = yup
  .object({
    region: yup.string().optional(),
    district: yup.string().optional(),
  })
  .required();
